// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("PurchaseHistory", {
  id: __t.u64(),
  userId: __t.u64(),
  purchaseType: __t.string(),
  stripeSessionId: __t.string(),
  stripePaymentIntent: __t.string(),
  amountCents: __t.i64(),
  coinsGranted: __t.i64(),
  description: __t.string(),
  status: __t.string(),
  createdAt: __t.u64(),
});


